import React, {Component} from 'react';
import {connect} from "react-redux";
import {fetchingAllBatteriesSelector, allBatteriesSelector} from "../redux/reducers/allBatteriesReducer";
import {fetchingAllUsersSelector, allUsersSelector} from "../redux/reducers/allUsersReducer";
import {openBatteryIdSelector} from "../redux/reducers/openReducer";
import {fetchAllBatteries} from "../redux/actionCreators/allBatteries";
import {fetchAllUsers} from "../redux/actionCreators/allUsers";
import {dk_blue, dk_gray, dk_light_gray} from "../constants/style";
import {PulseLoader} from "react-spinners";
import MaterialIcon from "material-icons-react";
import NavLink from "react-router-dom/es/NavLink";
import {connectedSelector, userSelector} from "../redux/reducers/authReducer";
import strings from "../screenLocalisation/connection";
import {disconnect} from "../redux/actionCreators/auth";
import Autocomplete from 'react-autocomplete';
import {setOpenBattery} from "../redux/actionCreators/open";
import {fetchBatteryById} from "../redux/actionCreators/batteryById";
import {fetchUserById} from "../redux/actionCreators/userById";
import {fetchBatteryByIdWithState} from '../redux/actionCreators/batteryById';





class AdminMenu extends Component {
    constructor(props){
        super(props)
        this.state = {
            menuVisible: true,
            dropDownVisible:false,
            value:'',
            adminActionSelected:''
        }
        window.addEventListener("resize", this.updateDimensions.bind(this));
    }

    componentWillUnmount() {
        window.removeEventListener("resize", this.updateDimensions.bind(this));
    }

    updateDimensions() {
        this.setState({
            menuVisible: !(window.innerWidth < 850)
        })
    }

    componentDidMount() {
        this.props.fetchAllBatteries()
        this.props.fetchAllUsers()
        this.updateDimensions();
        console.log(this.props.history)
    }

    toggleMenu() {
        this.setState({
            menuVisible: !this.state.menuVisible
        })
    }

    toggleDropdown() {
        this.setState( prevState => ({
            dropDownVisible: !prevState.dropDownVisible
        }))
    }

    disconnect() {
        this.props.disconnect()
        this.props.history.push('/login')
    }


    render() {

        return (
            <div>
                <div onClick={this.toggleMenu.bind(this)} className={this.state.menuVisible?'batteryMenuButton':'batteryMenuButton batteryMenuButtonOpen'}>
                    <MaterialIcon key={this.state.menuVisible} color={dk_blue} icon={this.state.menuVisible?'keyboard_arrow_left':'menu'} size={34}/>

                </div>

                {this.state.menuVisible?(
                    <div className={'batteryMenu'}>
                        <h1>ADMIN</h1>
                        {this.state.adminActionSelected?this.swtichMenu():
                            <div>
                                <div className={'adminBouton'} onClick={()=>this.setState({'adminActionSelected':'batteries'})}>Rechercher une batterie</div>
                                <div className={'adminBouton'} onClick={()=>this.setState({'adminActionSelected':'users'})}>Rechercher un utilisateur</div>
                                <div className={'adminBouton'} onClick={()=>(this.setState({'adminActionSelected':''}),this.props.fetchAllBatteries())}>Voir toutes les batteries</div>
                            </div>}





                        <div style={styles.profileInfo}>
                            <div style={styles.userInfos}>
                                <div style={styles.userText}>
                                    <p style={styles.userTextP}>{this.props.user.fullName}</p>
                                    {/*<p style={styles.userTextP}>{this.props.user.emailAddress}</p>*/}
                                </div>
                                <div onClick={this.toggleDropdown.bind(this)} className={'profilIcon'}>
                                    <div style={styles.profileLogo}>
                                        <div style={styles.logoWrap}>
                                            <MaterialIcon color={'white'} icon={'how_to_reg'} size={50}/>
                                        </div>
                                    </div>
                                </div>
                                {this.state.dropDownVisible?<div className={'dropdownMenuProfil'} onClick={this.disconnect.bind(this)}>{strings.disconnect}</div>:null}
                            </div>
                        </div>
                        <img className={'logoMenu'} src={require('../assets/img/logo_blue_small.png')} />

                    </div>
                ):null}
            </div>
        );
    }
    swtichMenu() {
        switch(this.state.adminActionSelected)
        {
            case 'batteries':
                return <div>
                    <div className={'adminBackButton'} onClick={()=>{
                        const value = this.setState({'value':''})
                        this.setState({'adminActionSelected':''})
                    }}>Retour</div>
                    <Autocomplete
                        items={this.props.batteries}
                        inputProps={{
                            id: "search",
                            name: "search",
                            component: "input",
                            className: "fieldInputSearchBar"
                        }}
                        wrapperProps={{
                            className: "wrapperInputSearchBar"
                        }}
                        wrapperStyle={{display: 'flex', position: 'relative'}}
                        menuStyle={{
                            boxShadow: '0 2px 12px rgba(0, 0, 0, 0.1)',
                            zIndex:"10",
                            background: 'rgba(255, 255, 255, 0.9)',
                            position:'absolute',
                            paddingLeft: "10px",
                            overflow: 'auto',
                            width: "100%",
                            top:"50px",
                            left:0,
                            maxWidth: "800px",
                            minWidth: "250px",
                            maxHeight: '500px', // TODO: don't cheat, let it flow to the bottom
                        }}
                        shouldItemRender={(item, value) => item.sn.toLowerCase().indexOf(value.toLowerCase()) > -1}
                        getItemValue={item => item.sn}
                        renderItem={(item, highlighted) =>
                            <div
                                key={item.id}
                                style={{
                                    backgroundColor: highlighted ? '#FFCC00' : 'white',
                                    fontSize: "18px",
                                    paddingTop: "3px",
                                    paddingBottom: "3px"
                                }}
                            >
                                {item.sn}
                            </div>
                        }
                        value={this.state.value}
                        onChange={e => this.setState({value: e.target.value})}
                        onSelect={(value, item) => (this.setState({value}), this.props.fetchBatteryById(item.id),this.props.setOpenBattery(item.id),this.props.fetchBatteryByIdWithState(item.id)
                        )}
                        autoHighlight={true}
                    />
                </div>
            case 'users':
                return <div>
                    <div className={'adminBackButton'} onClick={()=>{
                        const value = this.setState({'value':''})
                        this.setState({'adminActionSelected':''})
                    }}>Retour</div>
                    <Autocomplete
                        items={this.props.users}
                        inputProps={{
                            id: "search",
                            name: "search",
                            component: "input",
                            className: "fieldInputSearchBar"
                        }}
                        wrapperProps={{
                            className: "wrapperInputSearchBar"
                        }}
                        wrapperStyle={{display: 'flex', position: 'relative'}}
                        menuStyle={{
                            boxShadow: '0 2px 12px rgba(0, 0, 0, 0.1)',
                            zIndex:"10",
                            background: 'rgba(255, 255, 255, 0.9)',
                            position:'absolute',
                            paddingLeft: "10px",
                            overflow: 'auto',
                            width: "100%",
                            top:"50px",
                            left:0,
                            maxWidth: "800px",
                            minWidth: "250px",
                            maxHeight: '500px', // TODO: don't cheat, let it flow to the bottom
                        }}
                        shouldItemRender={(item, value) => item.fullName.toLowerCase().indexOf(value.toLowerCase()) > -1}
                        getItemValue={item => item.fullName}
                        renderItem={(item, highlighted) =>
                            <div
                                key={item.id}
                                style={{
                                    backgroundColor: highlighted ? '#FFCC00' : 'white',
                                    fontSize: "18px",
                                    paddingTop: "3px",
                                    paddingBottom: "3px"
                                }}
                            >
                                {item.fullName}
                            </div>
                        }
                        value={this.state.value}
                        onChange={e => this.setState({value: e.target.value})}
                        onSelect={async (value, item) => (this.setState({value}), this.props.fetchUserById(item.id))}
                        autoHighlight={true}
                    />

                </div>
            default:
                return null
        }
    }
}



const styles = {

    battery: {
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'space-between',
        width: 200,
        padding: 20,
    },
    batteryCharge: {
        color: 'white',
        margin: 0
    },
    batteryAlert: {
        flex: 2,
        display: 'flex',
        justifyContent: 'flex-start',
        alignItems: 'center',
        flexDirection: 'row',
    },
    batteryLabel: {
        paddingRight: 20,
        flex: 5,
    },
    batteryInfos: {
        flex: 1,
    },
    loader: {
        margin: 20
    },
    userInfos: {
        display: 'inline-flex',
        flexDirection: 'row',
        alignItems: 'center'
    },
    profileLogo: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        height: '100%'
    },
    connectIcon: {

    },
    userText: {
        display: 'flex',
        flexDirection: 'column',
        justifyItems: 'space=around',
        padding: '0 20px'
    },
    logoWrap: {
        height: 50
    },
    userTextP: {
        color: 'white'
    },
    profileInfo: {
        position: 'absolute',
        top: 5,
        right: 5
    }
}

const mapStateToProps = state => ({
    batteries: allBatteriesSelector(state),
    fetching: fetchingAllBatteriesSelector(state),
    connected: connectedSelector(state),
    user: userSelector(state),
    users: allUsersSelector(state),
    fetchingUsers: fetchingAllUsersSelector(state),
})

export default connect(mapStateToProps, {fetchAllBatteries,fetchAllUsers,setOpenBattery, disconnect, fetchBatteryById,fetchUserById,fetchBatteryByIdWithState})(AdminMenu);